import type { Component, Entity2D } from '../../odie';
import { ComboGlowAnimation } from '../animations/ComboGlowAnimation';

import { blockPositionView2 } from '../util/blockTools';

// types
//-----------------------------------------------------------------------------
export type GlowComponentOptions = {};

/*
    glowy highlight for other blocks
*/
export class GlowComponent implements Component {
  // constants
  //---------------------------------------------------------------------------
  public static readonly NAME = 'glow';

  // fields
  //---------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ComboGlowAnimation;

  // impl
  //---------------------------------------------------------------------------
  public init(options: GlowComponentOptions): void {
    this.view = new ComboGlowAnimation();

    // position view
    blockPositionView2(this.view, { width: 1, height: 1 });
  }

  public shutdown() {
    this.view.stop();
  }

  // api
  //---------------------------------------------------------------------------
  public start() {
    this.view.start();
  }

  public stop() {
    this.view.stop();
  }
}
